import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  oneTimeSubscriptionBundleId: null,
  defaultDailySubButtonEnabled: true,
  isWinnersMsisdnEnabled: false,
  paypalThresholdForBundle: null,
  paypalClientId: '',
  verification: {},
  fallingItemsAddOnGameCss: null,
  activeAddOnMiniGame: false,
  timerForPuzzleGame: '',
  phoneShortcutEnabled: false,
  homeScreenModalDisable: false,
  timerForLanternGame: null,
  freeTrialPoints: null,
  postGameSettings: null,
  servicePromotionModal: false,
  showCrossPromotionPhase: false,
  optOutPhase: false,
  pushNotificationsPublicKey: '',
  inviteReferral: '',
  inviteConfig: {},
  shareAchievementPoints: 0,
  messaging: {},
  needLoad: false,
  activeModals: [],
  timeToAcceptChallenge: null,
  freeTrialRedirectionUrl: null,
  showMaskProfileEdit: false,
  producedUniqueId: '',
  conversionForArabicFields: false,
  chatEnabled: false,
  minGamesToPlay: 0,
  cpc: null,
  correlationId: '',
  showMsisdnInProfilePage: false,
  availableFBLanguagesForSDK: Object.freeze({
    EN: 'en_US',
    AR: 'ar_AR',
    FA: 'fa_IR',
    FR: 'fr_FR',
  }),
  hideChangePassword: false,
  hideLangSelection: false,
  timeWinnerIndication: null,
  isAvatarGroupWithoutAccessories: false,
  hideLeaderboard: false,
  purchaseBundleFromUnsubUser: false,
  integrationConfig: {}, // active integration data
  simpleRegistration: '',
  showSelectOperatorModal: false,
  showNoBalanceModal: false,
  availableIntegrations: Object.freeze({
    MTN_RSA: 'mtn_rsa_he',
    BATELCO_BAHRAIN: 'batelco_bahrain_he',
    MONDIA_PAY_DENMARK: 'mondia_pay_denmark_he',
    KSA_MOBILY: 'ksa_mobily_he',
    IRAQ_ZAIN: 'iraq_zain_he',
    TPAY_EGYPT: 'tpay_egypt_he',
    KUWAIT_ZAIN: 'kuwait_zain_he',
    VIVA_KUWAIT: 'viva_kuwait_he',
    DU_ETISALAT: 'du_etisalat',
    SYRIATEL_SYRIA: 'syriatel_syria_he',
    MTN_SYRIA: 'mtn_syria_he',
    MYANMAR: 'myanmar_he',
    OOREDOO_ALGERIA: 'ooredoo_algeria_he',
    OMANTEL_OMAN: {
      name: 'omantel_oman_he',
      showRegistrationModal: true
    },
    ROSHAN: {
      name: 'roshan_afg',
    },
    // Mirrors Brainiac's entry. Duel routes this operator by name, not by these flags — its config is undefined.
    VODAFONE_OMAN: {
      name: 'vodafone_oman_he',
      hasAsync: true,
      oneTimeSubscription: true,
    },
  }),
  availableFlows: Object.freeze({
    DEFAULT: {
      propertyName: 'DEFAULT',
      blockedRoutes: [],
    },
    SIMPLE_WITH_WEB_REGISTRATION: {
      propertyName: 'SIMPLE_WITH_WEB_REGISTRATION',
      blockedRoutes: ['/forgotPassword2', '/forgotPassword3'],
    },
    SIMPLE_WITHOUT_WEB_REGISTRATION: {
      propertyName: 'SIMPLE_WITHOUT_WEB_REGISTRATION',
      blockedRoutes: ['/twostepregister1', '/forgotPassword2', '/forgotPassword3', '/twostepforgotPassword1'],
    },
    SIMPLE_BOTH_WEB_REGISTRATION_AND_LOGIN: { // Myanmar
      propertyName: 'SIMPLE_BOTH_WEB_REGISTRATION_AND_LOGIN',
      blockedRoutes: ['/resubscribeSteps', '/login', '/forgotPassword1', '/forgotPassword2', '/forgotPassword3', '/twostepforgotPassword1', '/twostepforgotPassword2'],
    },
  }),
  mergedParam: '',
  hidePrizePage: false,
  purchaseViaSMS: null,
  fbAppId: '',
  versionInfo: {},
  roundTimeList: [],
  multiOperatorInfo: {
    multiOperatorEnabled: false,
    multiOperatorOrdinal: 0,
    multiOperatorDisplayNames: [],
    operatorPicked: '',
    multiOperatorKeys: [],
    multiOperatorDisplayedNamesInRegisterPage: [],
  },
  winnersShowMsisdn: false,
  duelSkin: 0,
  puzzleGameCss: '',
  displayPrice: false,
  hideStore: false,
  smsAutomaticResponse: false,
  hideWinners: false,
  hideUserAchievements: false,
  facebookFunctionality: false,
  lastRandomRound: 0,
  banner: '',
  userAvatar: '',
  fbReferral: '',
  connectionPoints: 0,
  reoptinOnestep: false,
  refUrl: '',
  campaignId: '',
  publisherId: '',
  clickid: '',
  splashUrl: '',
  splashTimer: 0,
  profilePath: true,
  modalForChallenge: null,
  modalForHomePage: null,
  modalForSettings: null,
  modalForStore: null,
  avatarGrouping: 0,
  storeItems: [],
  pinForBundles: false,
  subAndUnsubViaSMS: false,
  twoStepRegistration: false,
  freeTrialStripe: false,
  logoOnFooter: false,
  trackingId: '',
  facebookPixelId: '',
  vatBanner: false,
  soundsOn: true,
  /**
   * Mapping for notifications
   * @property{string} text, equals the notificationCategoryDTO name
   * @property{string} value, equals the notificationCategoryDTO value
   * @property{string} notificationTitleTranslation, the translation for notification title (if applicable)
   * @property{string} notificationTextBeforeTranslation, the translation for notification description first part
   * @property{string} notificationTextAfterTranslation, the translation for notification description second part (if applicable)
   * @property{string} notificationButtonTranslation, the translation for notification 'check it' button
   * @property{string} showModal, the modal that will be shown on 'check it' button click
   * @property{boolean} dynamicText, if the notification description contains date (or other dynamic) info
   */
  addOnMode: null,
  addOnModesEnum: Object.freeze({
    DOUBLE_POINTS_OR_LOSE: {
      text: 'DOUBLE_POINTS_OR_LOSE',
      hide: false,
      assignPointsAfterAddOnGame: true,
      factor: 2,
      lostPointsForMissedAddOnGame: true,
    },
    TRIPLE_POINTS_OR_LOSE: {
      text: 'TRIPLE_POINTS_OR_LOSE',
      hide: false,
      assignPointsAfterAddOnGame: true,
      factor: 3,
      lostPointsForMissedAddOnGame: true,
    },
    ONLY_DOUBLE: {
      text: 'ONLY_DOUBLE',
      hide: false,
      assignPointsAfterAddOnGame: true,
      factor: 2,
      lostPointsForMissedAddOnGame: false,
    },
    ONLY_TRIPLE: {
      text: 'ONLY_TRIPLE',
      hide: false,
      assignPointsAfterAddOnGame: true,
      factor: 3,
      lostPointsForMissedAddOnGame: false,
    },
    NO_WIN_LOSE: {
      text: 'NO_WIN_LOSE',
      hide: false,
      assignPointsAfterAddOnGame: false,
    },
    HIDE: {
      text: 'HIDE',
      hide: true,
    },
  }),
  notificationsNames: Object.freeze({
    OneGamePlayed: {
      text: 'One Game Played',
      value: '',
      notificationTitleTranslation: 'home_notifications_one_game_played',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_one_game_played_button',
      showModal: '',
      profileLink: false,
      dynamicText: false,
    },
    GrandPrize: {
      text: 'Grand Prize',
      value: '',
      notificationTitleTranslation: 'home_modals_prize_details_grand_prize',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'PrizeDetails',
      profileLink: false,
      dynamicText: false,
    },
    DailyPrize: {
      text: 'Daily Prize',
      value: '',
      notificationTitleTranslation: 'home_modals_prize_details_daily_prize',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'PrizeDetails',
      profileLink: false,
      dynamicText: false,
    },
    WeeklyPrize: {
      text: 'Weekly Prize',
      value: '',
      notificationTitleTranslation: 'home_modals_prize_details_weekly_prize',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'PrizeDetails',
      profileLink: false,
      dynamicText: false,
    },
    MonthlyPrize: {
      text: 'Monthly Prize',
      value: '',
      notificationTitleTranslation: 'home_modals_prize_details_monthly_prize',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'PrizeDetails',
      profileLink: false,
      dynamicText: false,
    },
    TopRanking: {
      text: 'Top Ranking',
      value: 'Ranking',
      notificationTitleTranslation: '',
      notificationTextBeforeTranslation: 'notifications_bonus_ranking_before',
      notificationTextAfterTranslation: 'notifications_bonus_ranking_after',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'Ranking',
      profileLink: false,
      dynamicText: false,
    },
    LevelUp: {
      text: 'Level Up',
      value: '',
      notificationTitleTranslation: 'home_notifications_level_up',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'LevelUp',
      profileLink: false,
      dynamicText: false,
    },
    BonusRegistration: {
      text: 'Bonus Points',
      value: 'Registration',
      notificationTitleTranslation: 'home_modals_notifications_bonus_registration',
      notificationTextBeforeTranslation: 'notifications_bonus_registration_before',
      notificationTextAfterTranslation: 'notifications_bonus_registration_after',
      notificationButtonTranslation: '',
      showModal: '',
      profileLink: false,
      dynamicText: false,
    },
    BonusPointsRank: {
      text: 'Bonus Points',
      value: 'Ranking',
      notificationTitleTranslation: 'home_modals_notifications_bonus_games',
      notificationTextBeforeTranslation: 'notifications_bonus_ranking_before',
      notificationTextAfterTranslation: 'notifications_bonus_ranking_after',
      notificationButtonTranslation: '',
      showModal: '',
      profileLink: false,
      dynamicText: false,
    },
    BonusPointsReferral: {
      text: 'Free Game',
      value: 'Referral',
      notificationTitleTranslation: 'home_modals_notifications_bonus_referral',
      notificationTextBeforeTranslation: 'notifications_bonus_referral_registration_before_username',
      notificationTextAfterTranslation: 'notifications_bonus_referral_registration_after_username',
      notificationButtonTranslation: '',
      showModal: '',
      profileLink: true,
      dynamicText: false,
    },
    BonusPointsLevelUp: {
      text: 'Bonus Points',
      value: 'LevelUp',
      notificationTitleTranslation: 'home_modals_notifications_bonus_points',
      notificationTextBeforeTranslation: 'notifications_bonus_level_up_before',
      notificationTextAfterTranslation: 'notifications_bonus_level_up_after',
      notificationButtonTranslation: '',
      showModal: '',
      profileLink: false,
      dynamicText: false,
    },
    OfflineUser: {
      text: 'Offline User',
      value: 'Offline User',
      notificationTitleTranslation: '',
      notificationTextBeforeTranslation: 'notifications_offline_user_challenge_before',
      notificationTextAfterTranslation: 'notifications_offline_user_challenge_after',
      notificationButtonTranslation: 'home_notifications_challenge',
      showModal: '',
      profileLink: true,
      dynamicText: false,
    },
    BundleDiscount: {
      text: 'Bundle Discount',
      value: 'Bundle Discount',
      notificationTitleTranslation: 'notifications_bundle_discount_title',
      notificationTextBeforeTranslation: 'notifications_bundle_discount_before',
      notificationTextAfterTranslation: 'notifications_bundle_discount_after',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: '',
      profileLink: false,
      dynamicText: true,
    },
    BonusPointsPhase: {
      text: 'Bonus Points Phase',
      value: 'Bonus Points Phase',
      notificationTitleTranslation: 'notifications_bonus_points_phase_title',
      notificationTextBeforeTranslation: 'notifications_bonus_points_phase_before',
      notificationTextAfterTranslation: 'notifications_bonus_points_phase_after',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: '',
      profileLink: false,
      dynamicText: true,
    },
    NotEnoughBalance: {
      text: 'Not Enough Balance',
      value: 'Not Enough Balance',
      notificationTitleTranslation: '',
      notificationTextBeforeTranslation: 'notifications_no_balance_challenge_before',
      notificationTextAfterTranslation: 'notifications_no_balance_challenge_after',
      notificationButtonTranslation: 'home_notifications_store',
      showModal: '',
      profileLink: true,
      dynamicText: false,
    },
    ChangeUsernameOrPin: {
      text: 'Change Username or Pin',
      value: '',
      notificationTitleTranslation: 'home_notifications_change_username_or_pin_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_change_username_or_pin_button',
      showModal: '',
      profileLink: false,
      dynamicText: false,
    },
    VerifyEmail: {
      text: 'Email Verification',
      value: '',
      notificationTitleTranslation: 'home_notifications_verify_email_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_verify_email_button',
      showModal: '',
      profileLink: false,
      dynamicText: false,
    },
    Achievement: {
      text: 'Achievement',
      value: '',
      notificationTitleTranslation: 'home_notifications_achievement_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'NewAchievement',
      profileLink: false,
      dynamicText: false,
    },
    BonusPhasesDaily: {
      text: 'Bonus Phases Daily',
      value: '',
      notificationTitleTranslation: 'home_notification_bonus_phase_daily_bonus_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: '',
      profileLink: false,
      dynamicText: false,
    },
    SpinWheel: {
      text: 'Pending spinning wheel game',
      value: '',
      notificationTitleTranslation: 'home_notification_spin_wheel_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'SpinWheel',
      profileLink: false,
      dynamicText: true,
    },
    LootBox: {
      text: 'Pending loot box game',
      value: '',
      notificationTitleTranslation: 'home_notification_loot_box_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'LootBox',
      profileLink: false,
      dynamicText: true,
    },
    LightTheLanterns: {
      text: 'Pending light the lanterns game',
      value: '',
      notificationTitleTranslation: 'home_notification_light_the_lanterns_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'LightTheLanterns',
      profileLink: false,
      dynamicText: true,
    },
    Puzzle: {
      text: 'Pending puzzle game',
      value: '',
      notificationTitleTranslation: 'home_notification_puzzle_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'Puzzle',
      profileLink: false,
      dynamicText: true,
    },
    InvitationRegistration: {
      text: 'Invite',
      value: 'Invite',
      notificationTitleTranslation: 'notifications_invite_registration_title',
      notificationTextBeforeTranslation: 'notifications_invite_registration_before_username',
      notificationTextAfterTranslation: 'notifications_invite_registration_after_username',
      notificationButtonTranslation: 'home_notifications_challenge',
      showModal: '',
      profileLink: true,
      dynamicText: false,
    },
    CelebrityNotification: {
      text: 'Play with Celebrity',
      value: 'Play with Celebrity',
      notificationTitleTranslation: 'notifications_celebrity_text_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_play_now',
      showModal: '',
      profileLink: false,
      dynamicText: false,
    },
  }),
  userDetails: {
    displayAvatar: false,
    msisdn: '',
    level: 0,
    totalPointsEarned: 0,
    dailyPointsEarned: 0,
    weeklyPointsEarned: 0,
    monthlyPointsEarned: 0,
    gamesPlayed: 0,
    gamesWon: 0,
    answersGiven: 0,
    correctAnswersGiven: 0,
    availableGames: 0,
    freeGamesUntil: 0,
    language: '',
    gamesToNextLevel: 0,
    username: '',
    avatar: '',
    avatarGender: 'male',
    subscribed: '',
    facebookId: '',
    parked: '',
    cheatHelpCounter: '',
    fiftyFiftyHelpCounter: '',
    hasPhoneShortcut: '',
  },
  installPromptEvent: null,
  // OP014586-4 — Duel Vodafone-Oman (DV Pass) flow state (ported from Brainiac common/index.js).
  dvPassIdentificationId: null,
  dvPassResponse: null,
  isDailySubscription: false,
  dvPassChallenge: null,
  dvPassJWT: null,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/common/index.js